import React, { useState, useEffect } from "react";
import "./Footer.css";

function Footer() {
	const [count, setCount] = useState(0);

	useEffect(() => {
		fetch("https://words.openlava.com/heartbeat")
			.then((response) => response.json())
			.then((json) => {
				new Intl.DateTimeFormat("en-CA");
				setCount(json.data.toLocaleString());
			})
			.catch((error) => console.log(error));
	}, []);
	return (
		<footer className="footer">
			Notes:
			<ol>
				<li>
					The{" "}
					<cite>
						<a
							target="_blank"
							href="http://www.gwicks.net/dictionaries.htm"
							rel="noreferrer"
						>
							dictionary
						</a>
					</cite>{" "}
					contains {count} words but has not been scrubbed for
					completeness. There may be words missing or invalid words.
				</li>
				<li>
					The technology used is React on the front end that connects
					to a service using the Slim 4 framework and MySql.
				</li>
			</ol>
		</footer>
	);
}

export default React.memo(Footer);
